<div class="max-page-width">

  <div class="container-fluid" *ngIf="customerProfile!=null">

    <!-- Profile Info -->
    <div class="mt-4 profile-info">

        <div class="row m-0">
          <div class="col-md-9 row m-0 pl-md-0">
            <!--View Mode (View Image)-->
            <div class="col-lg-2 col-md-3 profile-bg p-2 border-raduis-tl text-center" *ngIf="view">
              <img class="img-circle user-profile img-fluid mr-2"
              [src]="profilePicUrl"
              />
            </div>
            <!-- Edit Mode (Edit Image)-->
            <div class="col-lg-2 col-md-3 profile-bg p-2 border-raduis-tl text-center" *ngIf="!view">
              <!-- <img class="img-circle user-profile img-fluid mr-2" src='assets/img/team_pic_4.jpg' /> -->
              <label class="" for="fileInput">

                <img

                class="rounded-circle user-profile img-fluid mr-2"
                [src]="profilePicUrl" >
                <div class="hover-text choose-file">{{ 'Choosefile' | translate }}</div>
                <div class="background"></div>
              </label>

              <input id="fileInput" type='file' (change)="onSelectFile($event)" style="display: none;">
            </div>
            <div class="col-lg-10 col-md-9 profile-bg border-raduis-tr ">
              <div class="row">
                <div class="col-lg-9 col-12">
                  <div class="user-name mt-md-2">{{customerProfile.firstName}} {{customerProfile.familyName}}</div>
                  <div class="text-muted mt-1 mb-2">{{customerProfile.nationalityName | translate}} | {{ 'JoinedSince' | translate }} {{customerProfile.joinDate}}</div>
                  <div class="mb-1">
                    <!-- <mat-icon class="custom-icon mr-2" svgIcon="booking-icon"></mat-icon> -->
                    <i class="fas fa-car mr-1"></i>
                    {{customerProfile.totalReservationCount}} {{ 'Bookings' | translate }} | {{customerProfile.activeReservations}} {{ 'Active' | translate }}</div>
                  <div class="mb-1">
                    <!-- <mat-icon class="custom-icon mr-2" svgIcon="payment-icon"></mat-icon> -->
                    <i class="fas fa-dollar-sign mr-2"></i>
                    {{customerProfile.totalReservationCharges | number}} {{currency}}</div>
                </div>
                <div class="col-lg-3 col-12 order-first order-lg-last">

                  <ul class="dropdown">
                    <li><span href="#"><mat-icon class="setting-profile">settings</mat-icon></span>
                        <ul>
                            <li><button (click)="EditProfile()" class="btn btn-default">{{ 'EditProfile' | translate }}</button></li>
                            <li><button (click)="ChangePassword()" class="btn btn-default">{{ 'ChangePassword' | translate }}</button></li>
                             <li><button (click)="ChangeEmail()" class="btn btn-default">{{ 'ChangeEmail' | translate }}</button></li> 
                        </ul>
                    </li>
                  </ul>

                </div>
              </div>
            </div>
          </div>
          <div class="col-md-3 d-flex profile-bg justify-content-center align-items-center">
            <div class="text-center ">
              <!-- <mat-icon class="champions-icon custom-icon mr-1" svgIcon="champions-icon"></mat-icon> -->
              <img title="Customer Evaluation" placement="bottom" class="customer-evaluation" src='/assets/img/icons/champions-icon.svg' />
              <div class="champions-text" *ngIf="customerEvaluation!=null">{{customerEvaluation.average}} {{customerEvaluation.resourceName}}</div>
              <div class="champions-text" *ngIf="customerEvaluation==null">{{ 'NoReviews' | translate }}</div>
            </div>
          </div>
        </div>


    </div>
  <div class="row">

  </div>

    <ng-container *ngIf="view" >
      <mat-tab-group class="booking-details" animationDuration="0ms" >

        <!--Personal Information -->
        <mat-tab label="{{ 'PersonalInformation' | translate }}">
          <div class="row">
            <div class="col-lg-10 col-md-12">
              <div class="row">
                <div class="col-md-12">
                  <div class="customerInfo mb-5">
                    <div class="d-flex mb-3"><mat-icon class="mr-3">person</mat-icon> {{customerProfile.genderText  | translate}} | {{customerProfile.age}} {{'Years' | translate}} | {{customerProfile.workplace | translate}} | {{customerProfile.occuptionName | translate}}</div>
                    <div class="d-flex mb-3"><mat-icon class="mr-3">room</mat-icon> {{address | translate}} </div>
                    <div class="d-flex mb-3 "><mat-icon class="mr-3">stay_primary_portrait</mat-icon> <span class="phone-num"> {{customerProfile.mobile1}}</span> </div>
                    <div class="d-flex mb-3"><mat-icon class="mr-3">email</mat-icon> {{customerProfile.primaryEmail}} </div>
                    <div class="d-flex mb-3"><mat-icon class="mr-3">account_box</mat-icon> {{ 'DrivingLicense' | translate }} {{customerProfile.identityDocument.driverLicenseNumber}} | {{ 'ExpiresIn' | translate }}  {{customerProfile.identityDocument.driverLicenseExpiryDateFormated}} <a class="ml-3 text-blue" (click)="loadDriverLinces()" >{{ 'View' | translate }}</a></div>
                    <div class="d-flex mb-3"><mat-icon class="mr-3">account_box</mat-icon> {{ 'Passport' | translate }} {{customerProfile.identityDocument.passportNumber}} |  {{ 'ExpiresIn' | translate }}  {{customerProfile.identityDocument.passportExpiryDateFormated}} <a class="ml-3 text-blue" (click)="loadPassport()">{{ 'View' | translate }}</a></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </mat-tab>

        <!--Billing Information -->
        <!--For Now we are not saving cards info-->
        <!-- <mat-tab label="{{ 'BillingInformation' | translate }}" >
        <view-payment></view-payment>
        <div class="mb-4 view-billing"></div>
        </mat-tab> -->

      </mat-tab-group>
    </ng-container>


    <ng-container *ngIf="!view">
      <edit-my-profile [customerProfile]="customerProfile" [identityAttachmnetModel]="identityAttachmnetModel" (onCancel)="changeViewType($event)" [profilePicAttachmnetID]="profilePicAttachmentId"></edit-my-profile>
    </ng-container>

  </div>

</div>
